import { AxiosResponse } from 'axios'
import { axiosInstance } from 'libs'
import { GetStoreRes } from 'types'

export const getStore = async (
  machine_id: string | number,
  store_id: string | number,
  unit_no: string | number,
  hit_date: string | number,
): Promise<AxiosResponse<GetStoreRes>> => {
  return axiosInstance.get(`/api/similarity-distance`, {
    params: {
      machine_id,
      store_id,
      unit_no,
      hit_date,
    },
  })
}
